import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

interface NewsCardProps {
  item: NewsItem;
  variant?: "default" | "wide";
}

export default function NewsCard({ item, variant = "default" }: NewsCardProps) {
  if (variant === "wide") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
      >
        <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={item.title}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <span className="text-xs font-medium text-accent-600">
            {item.category}
          </span>
          <h3 className="mt-1 line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-400">{item.date}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
    >
      <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={item.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2 text-xs">
          <span className="rounded bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
            {item.category}
          </span>
          <span className="text-foreground-400">{item.date}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm text-foreground-500">
          {item.excerpt}
        </p>
        <span className="mt-auto pt-3 text-xs text-foreground-400">
          {item.author}
        </span>
      </div>
    </Link>
  );
}